import { tags } from '@angular-devkit/core';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { log } from 'console';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { TagService } from '../tag.service';

@Component({
  selector: 'app-tags',
  templateUrl: 'tags.component.html',
  styleUrls: ['tags.component.css'],
})
export class TagsComponent implements OnInit, OnDestroy {

  @Input() tags: any[];
  @Input() suggestions: any[];
  
  @Output() tagAdded = new EventEmitter<any>();
  @Output() tagRemoved = new EventEmitter<any>();
  
  @ViewChild('tagInput') tagInput: NgModel;

  expanded = true;
  tagInputText = null;

  debouncedText = '';

  private changesSub: Subscription;

  constructor(private tagService: TagService) { }

  ngOnInit() {
    this.changesSub = this.tagInput.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe(tagInputText => {
        this.debouncedText = tagInputText;
      });

      //console.log(this.tags)
  }

  ngOnDestroy() {
    if (this.changesSub) {
      this.changesSub.unsubscribe();
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      if (!this.tagInputText) {
        return
      }
      else {
        if (event.shiftKey) {

          const filtered = this.tagService.filterSuggestions(this.suggestions, this.tags, this.debouncedText);
          if (filtered.length > 0) {
            this.tagAdded.emit(filtered[0]);
          }
        } else {
          this.tagAdded.emit({ name: this.tagInputText });
          this.tagInput.reset();
        }
      }
    }
  }
  
  onAdd() {
    if (!this.tagInputText) {
      return
    } else {
      this.tagAdded.emit({ name: this.tagInputText });
      this.tagInput.reset();
    }
  }

  onExpand() {
    this.expanded = !this.expanded;
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/questions/tagsComponent/tags/tags.component.ts